// PM5 Additional Stroke Data (CE060036) listener — attaches to an existing
// PM5Connection WITHOUT modifying pm5Connection.js. Emits 'crewz-stroke-watts'.
// Layout (LE): [0-2] elapsed 0.01 s · [3-4] stroke power W · [5-6] stroke cal/hr · [7-8] stroke count
import { startNotificationsSafe } from './bleNotify';

const STROKE_POWER_UUID = 'ce060036-43e5-11e4-916c-0800200c9a66';

export function parseStrokePower(dv) {
  if (!dv || dv.byteLength < 9) return null;
  return {
    elapsed: (dv.getUint8(0) | (dv.getUint8(1) << 8) | (dv.getUint8(2) << 16)) / 100,
    watts: dv.getUint16(3, true),
    strokeCount: dv.getUint16(7, true),
  };
}

export async function attachStrokePower(conn) {
  const char = conn?.characteristics?.[STROKE_POWER_UUID];
  if (!char) return () => {};
  const handler = (event) => {
    const d = parseStrokePower(event.target.value);
    if (d) window.dispatchEvent(new CustomEvent('crewz-stroke-watts', { detail: { ...d, t: Date.now() } }));
  };
  char.addEventListener('characteristicvaluechanged', handler);
  try {
    await startNotificationsSafe(char);
  } catch (e) {
    console.warn('PM5: stroke power notifications unavailable', e?.message);
    char.removeEventListener('characteristicvaluechanged', handler);
    return () => {};
  }
  return () => char.removeEventListener('characteristicvaluechanged', handler);
}

// The live PM5 link lives on window.pm5Connection (set by DeviceConnection).
export const activePM5 = (fallback) => window.pm5Connection || fallback;
